import { useIntl } from 'react-intl';
import Card from '@ui/Card';
import CardContent from '@ui/CardContent';
import Grid from '@ui/Grid';
import { lightGreyColor } from '@ui/styles/colors';
import FormFieldRecapItem from './FormFieldRecapItem';
import { IFormFieldRecapItemOptionComponentProperties } from './types';
import { recapGridItemStyle, recapCardStyle, recapCardContentStyle } from './styles';

const FormFieldRecapItemRadioListOption = ({
    fieldKey,
    option,
    inverted,
} : IFormFieldRecapItemOptionComponentProperties) => {
    const intl = useIntl();

    return (
        <Grid item xs={6} style={recapGridItemStyle}>
            <Card elevation={0} style={{ ...recapCardStyle, ...(inverted && { backgroundColor: lightGreyColor }) }}>
                <CardContent style={recapCardContentStyle}>
                    <FormFieldRecapItem
                        label={`${intl.formatMessage({ id: `fieldsChat.${fieldKey}.label` })}`}
                        value={intl.formatMessage({ id: `components.FormFieldRadioList.radioListOptions.${option}.label` })}
                    />
                </CardContent>
            </Card>
        </Grid>
    );
};

export default FormFieldRecapItemRadioListOption;

